import fetcher from '../fetcher';

export type MasterMenu = {
	id: string;
	title: string;
	parentId: string;
	url: string;
	order: number;
	menuKey: string;
	isActive: true;
	createdBy: string;
	createdDate: string;
	modifiedBy: string;
	modifiedDate: string;
};

export type MasterMenuPayload = {
	title: string;
	parentId: string | null;
	url: string;
	order: number;
	menuKey: string;
	isActive: boolean;
};

export const getMasterMenus = () => {
	return fetcher<MasterMenu[]>({
		api: '/mastermenus/get-all-master-menu',
	});
};

export const getMasterMenu = (id: string) => {
	return fetcher<MasterMenu>({
		api: '/mastermenus/get-master-menu',
		body: {
			id,
		},
	});
};

export const createMasterMenu = (payload: MasterMenuPayload) => {
	return fetcher<string>({
		api: '/mastermenus/create-master-menu',
		body: payload,
	});
};

export const updateMasterMenu = (id: string, payload: MasterMenuPayload) => {
	return fetcher<string>({
		api: '/mastermenus/update-master-menu',
		body: {
			id,
			...payload,
		},
	});
};
